import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { IGNORE_ERRORS, DENY_URLS, beforeSend } from './utils/sentryFilter';
import './design/fonts.css';
import './index.css';

// GlitchTip/Sentry client-side error tracking.
// Defensive: wrapped in try/catch so a bad/missing DSN can never block app render.
// No-op unless REACT_APP_GLITCHTIP_DSN is baked in at build time.
try {
  if (process.env.REACT_APP_GLITCHTIP_DSN) {
    Sentry.init({
      dsn: process.env.REACT_APP_GLITCHTIP_DSN,
      environment: process.env.NODE_ENV || 'production',
      tracesSampleRate: 0,
      ignoreErrors: IGNORE_ERRORS,
      denyUrls: DENY_URLS,
      beforeSend,
    });
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.error('[sentry] init skipped', e);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 20 }}>Something went wrong. Please refresh the page.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
